import { Typography } from '@mui/material'

import type React from 'react'
import type { TypographyProps } from '@mui/material'

type BlockContentTypographyValue = {
  value?: {
    children?: unknown[]
  }
}

interface BlockContentTypographyProps extends TypographyProps {
  value?: BlockContentTypographyValue
}

export const BlockContentTypography: React.FC<BlockContentTypographyProps> = ({ value, children, ...props }) => {
  const blockContentValue = value?.value?.children?.[0]
  const blockContentText =
    typeof blockContentValue === 'object' &&
    blockContentValue !== null &&
    'text' in blockContentValue &&
    typeof blockContentValue.text === 'string'
      ? blockContentValue.text
      : undefined
  const hardBreakLine = blockContentText === ''
  if (!hardBreakLine) {
    return <Typography {...props}>{children}</Typography>
  } else {
    return <br />
  }
}
